// Module 6 / Slice 5 — Vehicle detail Assignments tab.
//
// Lists crewing.crew_assignment rows for the current vehicle. Each row
// embeds the EmployeeReference composite resolved via the M4
// IEmployeeReferenceReader port server-side (§4.6); the SPA only renders
// the display name. Drag-to-reorder + bulk-assign UX is carry C-mod6-17
// (Phase 4); v1 ships the read + data-testid surface.

import type { components } from "../../../api/crewing.gen";
import { useI18n } from "../../../i18n/I18nContext";

type CrewAssignment = components["schemas"]["CrewAssignment"];

export function AssignmentsTab({
  vehicleId,
  assignments,
}: {
  vehicleId: string;
  assignments: readonly CrewAssignment[];
}): JSX.Element {
  const { t } = useI18n();
  if (assignments.length === 0) {
    return (
      <p data-testid={`assignments-tab-empty-${vehicleId}`}>
        {t("crewing.assignments.empty")}
      </p>
    );
  }
  return (
    <table className="rc-table" data-testid="assignments-tab-table">
      <thead>
        <tr>
          <th>{t("crewing.assignments.col.employee")}</th>
          <th>{t("crewing.assignments.col.position")}</th>
          <th>{t("crewing.assignments.col.effectiveFrom")}</th>
          <th>{t("crewing.assignments.col.effectiveTo")}</th>
          <th>{t("crewing.assignments.col.isPrimary")}</th>
        </tr>
      </thead>
      <tbody>
        {assignments.map((a) => (
          <tr key={a.id} data-testid={`assignment-row-${a.id}`}>
            <td data-testid={`assignment-employee-${a.id}`}>
              {a.employee?.displayName ?? a.employeeId}
            </td>
            <td>{a.crewPositionId}</td>
            <td>{a.effectiveFrom}</td>
            <td>{a.effectiveTo ?? "—"}</td>
            <td data-testid={`assignment-primary-${a.id}`}>
              {a.isPrimary ? "★" : ""}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
